import { render, staticRenderFns } from "./FeatureMask.vue?vue&type=template&id=036a312c&scoped=true&"
import script from "./FeatureMask.vue?vue&type=script&lang=js&"
export * from "./FeatureMask.vue?vue&type=script&lang=js&"
import style0 from "./FeatureMask.vue?vue&type=style&index=0&id=036a312c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a312c",
  null
  
)

export default component.exports